import Swiper from "swiper";

export async function glideBrandsInit() {
  const elements = document.querySelectorAll(".swiper--brands");

  if (elements.length) {
    elements.forEach((slider) => {
      const scrollbar = slider.querySelector(".swiper-scrollbar");
      const gap = 30;
      const swiper = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: gap,
        freeMode: true,
        scrollbar: {
          el: scrollbar,
          hide: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      const rightButton = slider.querySelector(".glide__arrow--right");
      if (rightButton) {
        rightButton.addEventListener("click", () => {
          swiper.slideNext();
        });
      }
      const leftButton = slider.querySelector(".glide__arrow--left");
      if (leftButton) {
        leftButton.addEventListener("click", () => {
          swiper.slidePrev();
        });
      }

      function updateButtonVisibility() {
        if (leftButton) {
          leftButton.style.display = swiper.isBeginning ? "none" : "block";
        }
        if (rightButton) {
          rightButton.style.display = swiper.isEnd ? "none" : "block";
        }
      }

      updateButtonVisibility();

      swiper.on("slideChange", updateButtonVisibility);
      swiper.on("reachBeginning", updateButtonVisibility);
      swiper.on("reachEnd", updateButtonVisibility);

      slider.addEventListener("mouseover", () => {
        const buttons = slider.querySelectorAll(
          ".glide__arrow--left, .glide__arrow--right"
        );
        buttons.forEach((btn) => (btn.style.display = "block"));
        updateButtonVisibility();
      });

      slider.addEventListener("mouseout", () => {
        const buttons = slider.querySelectorAll(
          ".glide__arrow--left, .glide__arrow--right"
        );
        buttons.forEach((btn) => (btn.style.display = "none"));
      });
    });
  }
}
